import * as React from "react";
import {authorize, Overlay} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {AnnualPolicyInfo, ICustomerPortalService, Policy, ProductsEnum, Subscription, Types} from "@falcon/services";
import {RouteComponentProps} from "react-router-dom";
import {finalize, find, mergeMap} from "rxjs/operators";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {YourCarCoverPanel} from "../yourCarCover/YourCarCoverPanel";

interface IOldPolicySummaryPageParams {
    policyNumber: string;
}

interface IOldPolicySummaryPageProps extends RouteComponentProps<IOldPolicySummaryPageParams> {
    location: any;
}

interface IOldPolicySummaryPageState {
    loadingQueueSize: number;
    subscription?: Subscription;
    policy?: Policy;
}

@authorize
export class OldMotorPolicySummaryPage extends React.Component<IOldPolicySummaryPageProps, IOldPolicySummaryPageState> {
    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IOldPolicySummaryPageProps) {
        super(props);

        this.state = {
            loadingQueueSize: 0,
        };
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Old Policies");

        this.incrementLoadingQueueSize(() => {
            this.customerPortalService
                .getSubscription()
                .pipe(finalize(this.decrementLoadingQueueSize))
                .subscribe((subscription: Subscription) => {
                    this.setState({ subscription });
                });
        });

        this.incrementLoadingQueueSize(() => {
            this.customerPortalService
                .getExpiredPolicies(ProductsEnum.WOLF_MOTOR)
                .pipe(
                    finalize(this.decrementLoadingQueueSize),
                    mergeMap(policies => policies),
                    find(policy => policy.policyNumber === this.props.match.params.policyNumber),
                )
                .subscribe(policy => {
                    this.customerPortalService.getAnnualPolicyInfo(policy!.policyNumber).subscribe((annualPolicyInfo: AnnualPolicyInfo) => {
                        policy!.annualPolicyInfo = annualPolicyInfo;
                        this.setState({ policy });
                    });
                });
        });
    }

    public render() {
        return (
            <>
                <FalconHeader />
                <Overlay show={this.isLoading()} />
                <div className="page-contents">
                    {this.pluginTemplates.renderBackLink("Back", true, "/dashboard/annualMotorOldPolicies")}
                    <h1 className="page-heading-white">Policy summary</h1>
                    {!this.isLoading() && this.renderPolicy()}
                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard/annualMotorOldPolicies")}
                </div>
                <FalconFooter />
            </>
        );
    }

    private renderPolicy = () => {
        if (!this.state.subscription || (this.state.policy && !this.state.policy.annualPolicyInfo)) {
            return null;
        }

        if (!this.state.policy) {
            return (
                <div className="panel">
                    <p className="m-0 font-weight-extra-light">Policy does not exist</p>
                </div>
            );
        }

        return (
            <YourCarCoverPanel
                policy={this.state.policy}
                subscription={this.state.subscription}
                annualPolicyInfo={this.state.policy.annualPolicyInfo}
                vehicleIndex={0}
                isOldPolicy={true}
                renewalProposal={undefined}
                renewalEnabled={false}
            />
        );
    };

    private incrementLoadingQueueSize = (callback?: () => void) => {
        this.setState(
            {
                loadingQueueSize: this.state.loadingQueueSize + 1,
            },
            callback,
        );
    };

    private decrementLoadingQueueSize = (callback?: () => void) => {
        if (this.state.loadingQueueSize === 0) {
            return;
        }

        this.setState(
            {
                loadingQueueSize: this.state.loadingQueueSize - 1,
            },
            callback,
        );
    };

    private isLoading = () => {
        return this.state.loadingQueueSize !== 0;
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/motor/oldPolicies/OldMotorPolicySummaryPage.tsx